define('uikit/modules/popup',['require','exports','module','underscore','marionette','backbone','../channel','../mixins/component.mixin','../helper/dom','templates','../behaviors/fixed.popup.behavior','../definitions/modules/popup'],function(require, exports, module){
  var _                  = require('underscore');
  var Mn                 = require('marionette');
  var Backbone           = require('backbone');
  var channel            = require('../channel');
  var ComponentMixin     = require('../mixins/component.mixin');
  var DOMHelper          = require('../helper/dom');
  var Templates          = require('templates');
  var FixedPopupBehavior = require('../behaviors/fixed.popup.behavior');
  require('../definitions/modules/popup');

  var DefaultContentView = Mn.ItemView.extend(ComponentMixin).extend({

    options: {
      header: '',
      text: ''
    },

    forceUpdate: { header: true, text: true },

    template: Templates.App['default.popup']

  });

  var Popup = Mn.ItemView.extend(ComponentMixin).extend({

    className: 'ui popup',

    template: Templates.App['popup'],

    options: {
      basic      : false,
      borderless : false,
      compact    : false,
      content    : 'default',
      context    : 'body',
      duration   : 200,
      exclusive  : true,
      fixed      : false,
      flowing    : false,
      fluid      : false,
      hoverable  : false,
      inline     : false,
      inverted   : false,
      movePopup  : true,
      position   : 'top left',
      showOn     : 'hover',
      size       : '',
      transition : 'slide down',
      visible    : false,
      width      : ''
    },

    forceUpdate: {
      basic     : true,
      content   : true,
      context   : true,
      duration  : true,
      exclusive : true,
      fixed     : true,
      flowing   : true,
      fluid     : true,
      hoverable : true,
      inline    : true,
      inverted  : true,
      movePopup : true,
      position  : true,
      showOn    : true,
      size      : true,
      transition: true,
      width     : true
    },

    behaviors: function() {
      var behaviors;
      if (_.isFunction(this.getOption('behaviors'))) {
        behaviors = {};
      } else {
        behaviors = this.getOption('behaviors');
      }

      if (this.getOption('fixed')) {
        _.extend(behaviors, {
          FixedPopupBehavior: {
            behaviorClass: FixedPopupBehavior
          }
        })
      }
      return behaviors;
    },

    initialize: function() {
      ComponentMixin.initialize.apply(this, arguments);
      this.listenTo(this, 'change:content', this._processContent);
      this._processContent();
      this.once('popup:show', function() {
        this.triggerMethod('show');
      }, this);
      var self = this;
      this.$el
      .on(this.$el.transition('get animationStartEvent'), function() {
        self._animating = true;
        self.triggerMethod('animation:start');
      })
      .on(this.$el.transition('get animationEndEvent'), function() {
        self._animating = false;
        self.triggerMethod('animation:end');
      });
    },

    _processContent: function(self, newContent, prev) {
      if (prev instanceof Backbone.View && prev !== newContent) {
        // detach the previous since it is no longer needed
        prev.$el.detach();
      }
      if (_.isString(this.content)) {
        switch (this.content) {
          case 'default':
            this.content = new DefaultContentView();
            break;
        }
      } else if (this.content instanceof Backbone.View) {
        if (!this.content.isRendered && this.isRendered) {
          this.content.render();
        }
        if (this._isShown) {
          Mn.triggerMethodOn(this.content, 'before:show');
        }

        // Will be handled by internal views
        // this.$el.append(this.content.$el);

        if (this._isShown) {
          Mn.triggerMethodOn(this.content, 'show');
        }
      }
    },

    _show: function() {
      var views = this.getViews(),
          self  = this;

      self.$el.removeClass('hidden');

      if (views) {
        // if (this._animating) {
        //   this.once('animation:end', function() {
        //     self._show();
        //   });
        // } else if (views.trigger.$el.popup('is visible') === true) {
        //   views.trigger.$el.popup('hide', function() {
        //     self._show();
        //   })
        // } else {
          views.trigger.$el.popup('show', function() {
            self.triggerMethod('popup:shown');
          });
        // }
      }
    },

    _hide: function() {
      var views = this.getViews(),
          self = this;

      if (views) {
        views.trigger.$el.popup('hide', function() {
          self.triggerMethod('popup:hidden');
        });
      }
    },

    reposition: function() {
      var views = this.getViews();

      if (views) {
        views.trigger.$el.popup('reposition');
      }
    },

    getViews: function() {
      return this._showNow || this._popups[0];
    },

    onPopupShow: function() {
      this.visible = true;
    },

    onPopupHide: function() {
      this.visible = false;
      // there is an extremely annoying bug
      // that does not allow popups to be centered
      // correctly after the first time it is
      // shown
      this.$el.removeClass('hidden');
    },

    onPopupHidden: function() {
      // there is an extremely annoying bug
      // that does not allow popups to be centered
      // correctly after the first time it is
      // shown
      this.$el.removeClass('hidden');
    },

    onRender: function() {
      var self = this;
      _.each(this._showNow ? [this._showNow] : this._popups, function(views) {
        var options = _.omit(this.options, 'content');
        options.popup = this.$el;
        options.on = this.showOn;

        options.target = views.target.el;

        _.each(['create', 'remove', 'show', 'visible', 'hide', 'hidden'], function(eventName) {
          options['on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1)] = function() {
            self.triggerMethod('popup:' + eventName, self);
          };
        });

        // Used to allow keyboard Enter event
        if ((this.showOn).toLowerCase() == 'click') {
          if (!views.trigger._initialPopupListener) {
            views.trigger._initialPopupListener = true;

            views.trigger.$el.on('keydown', function(ev) {
              if (ev.keyCode == 13 & !views.trigger.disabled) {
                views.trigger.$el.popup('toggle');
              }
            });
          }
        }

        var self = this;

        this.$el.off('keydown.trigger');

        this.$el.on('keydown.trigger', function(ev) {
          // If user presses ESCAPE key hide and focus trigger element
          if (ev.keyCode == 27) {
            self.hide();

            views.trigger.$el.focus();
          } else if (ev.keyCode == 9) {
            var focusable = DOMHelper.focusable(self.el),
                shiftKey  = ev.shiftKey,
                length    = focusable.length,
                focusedEl = document.activeElement;

            // If the next tab item is not within the popup,
            if ((focusable.get(length-1) == focusedEl && !shiftKey) ||
                (focusable.get(0) == focusedEl && shiftKey)) {

              // Hide and focus the trigger element
              self.hide();

              ev.preventDefault();

              views.trigger.$el.focus();
            }
          }
        });

        views
            .trigger
            .$el
            .popup('destroy')
            .popup(options);

        if (this.visible) {
          this._show();
        } else {
          this._hide();
        }

      }, this);
    },

    updateAttributes: function() {
      this
          .addClass('fluid', this.getBoolOption('fluid') && this.getBoolOption('flowing'))
          .addClass('flowing', this.getBoolOption('flowing'))
          .addClass('inverted', this.getBoolOption('inverted'))
          .addClass('basic', this.getBoolOption('basic'))
          .addClass('compact', this.getBoolOption('compact'))
          .addClass('borderless', this.getBoolOption('borderless'))
          .addClass('fixed', this.getBoolOption('fixed'))
          .addClass(this.getOption('size'))
          .addClass(this.getOption('width'))
    },

    showNow: function(targetView) {
      this._showNow = { trigger: targetView, target: targetView };

      if (targetView.isRendered) {
        this.render();
      } else {
        targetView.once('render', this.render, this);
      }

      this.show({ force: true });
    },

    attach: function(triggerView, targetView) {
      var popups = this._popups || (this._popups = []);

      if (arguments.length < 2) {
        targetView = triggerView;
      }

      popups.push({
        trigger: triggerView,
        target: targetView
      });

      // the rendering of the dropdown relies on the rendering of its target views
      targetView.once('render', this.render, this);

      return this;
    }

  },
  {
    WIDE      : 'wide',
    VERY_WIDE : 'very wide',

    HUGE      : 'huge',
    LARGE     : 'large',
    SMALL     : 'small',

    TOP_RIGHT: 'top right',
    TOP_LEFT: 'top left',

    BOTTOM_LEFT: 'bottom left',
    BOTTOM_RIGHT: 'bottom right'
  });

  Popup.DefaultContentView = DefaultContentView;

  channel.reply('popup', function() {
    return Popup;
  });

  module.exports = Popup;
});

